import dayjs from 'dayjs';

export default {
	methods: {
		updatePickupDateTimeMethod(newValue) {
			console.log("hei you",newValue);

			this.pickUpDateTime = newValue;
			//check if now this.pickUpDateTime is later than  this.returnDateTime, if it is, the return should also change,otherwise the return keeps the same				const returnDate = dayjs(newValue).add(0, 'hour').toDate();// this 0 value could be dynamic for different clients, in this case, it should get the env file
			this.compareDates(this.pickUpDateTime,this.returnDateTime);
		},

		updateReturnDateTimeMethod(newValue) {
			this.returnDateTime = newValue;
			console.log("this.returnDateTime",this.returnDateTime);
			this.selectReturnDateTime = true;

		},

		compareDates(pickUpDateTime, returnDateTime) {
			if(pickUpDateTime.getTime() >= returnDateTime.getTime()) {
				console.log("pickUpDateTime.getTime()",pickUpDateTime.getTime());
				console.log("returnDateTime.getTime()",returnDateTime.getTime());
				this.updateReturnDateTimeMethod(pickUpDateTime);

			}
		}
	}
}
